<template>
  <ValidationProvider
    v-if="isShow"
    v-slot="{ errors }"
    tag="div"
    :name="name"
    :rules="rules"
    :class="{ 'with-hint': fieldProps.hint }"
  >
    <h5 v-if="caption.title" class="text-uppercase mt-5 mb-3">{{ caption.title }}</h5>

    <info-field
      v-if="caption.hintAbove"
      v-html="caption.hintAbove"
      :variant="caption.hintAboveVariant"
      class="mb-3"
    />

    <component
      v-bind="fieldProps"
      :value="inputValue"
      :prev-value="prevValue"
      :is="component"
      :disabled="field.disabled"
      :error-messages="errors"
      :key="componentKey"
      persistent-hint
      @input="handleInput"
    />

    <info-field
      v-if="caption.hintBelow"
      v-html="caption.hintBelow"
      :variant="caption.hintBelowVariant"
      class="mb-3 mt-3"
    />
  </ValidationProvider>
</template>

<script>
import components from '@/components/form-generator/constants/config';
import fieldsParams from '@/components/form-generator/constants/fields';
import { ValidationProvider } from 'vee-validate';

export default {
  props: {
    value: null,
    prevValue: null,
    field: {
      type: Object,
      required: true,
    },
    meta: {
      type: Object,
    },
  },
  data() {
    return {
      inputValue: null,
      componentKey: 0,
    };
  },
  computed: {
    config: () => components,
    fieldProps() {
      return this.fieldsParams[this.name];
    },
    isShow() {
      const hasComponent = this.component in this.config;

      return hasComponent && this.isDependOn;
    },
    isDependOn() {
      const { dependOn } = this.fieldProps;

      if (!dependOn) {
        return true;
      }

      const { value, param, comparator } = dependOn;
      const metaValue = this.meta[param];

      if (comparator) {
        return comparator(metaValue);
      }
      if (Array.isArray(value)) {
        return value.includes(metaValue);
      }
      return metaValue === value;
    },
    name() {
      return this.field.name;
    },
    component() {
      if (!this.fieldProps) return;

      const { component } = this.fieldProps;
      return component;
    },
    rules() {
      return this.fieldProps.validation;
    },
    caption() {
      const { caption = { title: '', hintAbove: '', hintBelow: '' } } = this.fieldProps;

      return caption;
    },
  },
  watch: {
    isShow(value) {
      if (!value) {
        this.$emit('input', null);
      }
    },
    prevValue: {
      handler(value) {
        this.inputValue = value;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    reRender() {
      this.componentKey += 1;
    },
    handleInput(value) {
      this.inputValue = value;
      this.$emit('input', value);
    },
    returnOldValue() {
      this.inputValue = this.prevValue;
    },
  },
  mixins: [fieldsParams],
  components: {
    ...components,
    ValidationProvider,
  },
};
</script>
